import { CarouselImage } from '../types';

/**
 * Configuración de imágenes del carrusel
 */
export const carouselImages: CarouselImage[] = [
  {
    src: '/assets/img/oficina/ofi1.webp',
    alt: 'Living de atención de Conectemos Chile, espacio cálido para sesiones de terapia',
    srcset: '/assets/img/oficina/ofi1.webp 740w'
  },
  {
    src: '/assets/img/oficina/ofi2.webp',
    alt: 'Escritorio y área de trabajo con vista a la calle en las oficinas de Conectemos Chile',
    srcset: '/assets/img/oficina/ofi2.webp 740w'
  },
  {
    src: '/assets/img/oficina/ofi2_frontal.webp',
    alt: 'Recepción de Conectemos Chile, luz natural y ambiente acogedor',
    srcset: '/assets/img/oficina/ofi2_frontal.webp 740w'
  },
  {
    src: '/assets/img/oficina/ofi_largo.webp',
    alt: 'Sala de terapia con sillones y certificaciones profesionales en la pared',
    srcset: '/assets/img/oficina/ofi_largo.webp 740w'
  },
  {
    src: '/assets/img/oficina/ofi_largo2.webp',
    alt: 'Vista general de la sala de terapia de Conectemos Chile',
    srcset: '/assets/img/oficina/ofi_largo2.webp 740w'
  }
];